import React, { FC } from "react";
import { Progress } from "@mantine/core";
import { abbreviateNumber } from "../../helpers/abbreviate";
import { useMediaQuery } from "@mantine/hooks";

const ChannelProgress: FC<{ channel: any }> = ({ channel }) => {
  const outbound = channel.local_balance - channel.local_reserve;
  const inbound = channel.remote_balance - channel.remote_reserve;
  const totalOfInboundAndOutbound = outbound + inbound;

  const isMobile = useMediaQuery("(max-width: 768px)");
  // Determine when to show the full label, just the number, or nothing
  const outBoundPercentage = (outbound / totalOfInboundAndOutbound) * 100;
  const inboundPercentage = (inbound / totalOfInboundAndOutbound) * 100;

  const outBoundBigEnoughToShow = outBoundPercentage > 3;
  const inBoundBigEnoughToShow = inboundPercentage > 3;

  const outBoundBigEnoughForLabel =
    (outBoundPercentage > 15 && !isMobile) ||
    (outBoundPercentage > 30 && isMobile);
  const inBoundBigEnoughForLabel =
    (inboundPercentage > 15 && !isMobile) ||
    (inboundPercentage > 30 && isMobile);

  // Style to ensure the full number is visible, removing ellipsis
  const labelStyle: React.CSSProperties = {
    whiteSpace: "nowrap", // Keep the text in one line
    overflow: "hidden", // Make sure the full text is visible
    display: "inline-block",
    textOverflow: "clip",
    letterSpacing: "0.09em",
    opacity: 0.79,
  };

  // Format number based on mobile or desktop view
  const formatNumber = (value: number, percentage: number) => {
    if (isMobile || percentage < 10) {
      return abbreviateNumber(value, 1);
    } else {
      return value.toLocaleString();
    }
  };

  return (
    <Progress.Root size={19} mt="xs" mb="xs" radius="md">
      <Progress.Section
        value={(outbound / totalOfInboundAndOutbound) * 100}
        color="#00000000"
      >
        {outBoundBigEnoughToShow && (
          <Progress.Label style={labelStyle}>
            {formatNumber(outbound, outBoundPercentage)}{" "}
            {outBoundBigEnoughForLabel ? "outbound" : ""}
          </Progress.Label>
        )}
      </Progress.Section>
      <Progress.Section
        value={(inbound / totalOfInboundAndOutbound) * 100}
        color="blue"
      >
        {inBoundBigEnoughToShow && (
          <Progress.Label style={labelStyle}>
            {formatNumber(inbound, inboundPercentage)}{" "}
            {inBoundBigEnoughForLabel ? "inbound" : ""}
          </Progress.Label>
        )}
      </Progress.Section>
    </Progress.Root>
  );
};

export default ChannelProgress;
